module.exports = __webpack_public_path__ + "static/media/Sonal.266381e8.jpg";